import module from '@@/package.json'

export default defineAppConfig({
	version: module.version,
	name: module.name,
	description: module.description,
	author: module.author,
})
